/** @jsx jsx */
import { jsx, } from '@emotion/core';
import styled from '@emotion/styled';
import { Rating, } from '@argo/ui-elements';
import { colors, typography, } from '@argo/principles';

interface SubHeader {
  isBold: boolean;
}

const FontStarSubHeader = styled.div<SubHeader>`
  font-size: 14px;
  ${(props,): string => (props.isBold
    ? `
    font-family: ${typography.family.montserrat};
    font-weight: ${typography.weight.bold};
    color: ${colors.primary.black};
  ` : `
    font-family: ${typography.family.opensans};
    font-weight: ${typography.weight.regular};
    color: ${colors.primary.charcoal};`)
}
`;

const StarWrapper = styled('div',)`
  align-items: center;
  display: flex;
  padding-top: 5px;
  padding-bottom: 11px;
  flex-direction: row;
`;

export default ({ id, label, rating, }: any,): JSX.Element => (
  <StarWrapper style={{ alignItems: 'center', }}>
    <FontStarSubHeader isBold>
      {rating === 0 ? '--' : Number(rating,).toPrecision(2,)}
      &nbsp;&nbsp;
    </FontStarSubHeader>
    <Rating ratingId={id} rating={1} maxRating={1} />
    <FontStarSubHeader id={label} isBold={false}>
      &nbsp;
      {label}
    </FontStarSubHeader>
  </StarWrapper>
);
